import React from "react";
import { connect } from "react-redux";
import { Button } from "devextreme-react";
import { Column, RemoteOperations, Paging, Pager } from "devextreme-react/ui/data-grid";
import DataGrid from "devextreme-react/ui/data-grid";
import moment from "moment";
import LoadingGif from "../../../../../images/animacion2[18].gif";
import {
  setShowHideForm,
  doGetDraft,
  setStep,
  setTipoSolicitud,
  loadDataSelected,
  loadDataGrid,
  setSolicitudesEmpresaFiltrada,
  setCleanSolicitudConfirmar,
  openCloseModalGestionar
} from "./actions";
import { formatDateForFilter } from "../../../../../helpers/dateFormat";
import { filterType, filterData } from "../../../../../helpers/filterHelper";
import TableFilter from "../../../../Shared/tableFilter.jsx";
import validaciones from "../../../../../helpers/validaciones";
import UserInfoColumn from "../../../../Shared/UserInfoColumn";
import ModalGestionar from "./Components/ModalGestionar";
import ModalVer from "../../../../Shared/ModalVer"
import { async } from "q";

class TableSolicitudes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      filtersLoaded: false,
      openModalVer: false,
      dataModalVer: null
    };
    this.mainFilter = (_obj) => {
      const _arr = [
        {
          Icon: "4", name: "Pendientes de aprobación", column: "estadoSolicitud", value: { text: "ingresado", value: 1 },
        },
        {
          Icon: "6", name: "Rechazadas por aprobador", column: "estadoSolicitud", value: { text: "rechazado", value: 3 },
        },
        {
          Icon: "0", name: "Aprobadas", column: "estadoSolicitud", value: { text: "aprobado", value: 2 },
        },
        {
          Icon: "6", name: "Rechazadas por ejecutivo", column: "estadoSolicitud", value: { text: "rechazadoCallCenter", value: 9 },
        },
        {
          Icon: "b", name: "Agendadas", column: "estadoSolicitud", value: { text: "agendado", value: 4 },
        },
      ];
      if (_obj) { return _arr.find((e) => e.value.value === _obj.value.value); }
      return _arr;
    };
  }

  componentDidMount = (prevProps) => {
    this.props.dispatch(setSolicitudesEmpresaFiltrada([]));
    if (!this.state.filtersLoaded) {
      // From: 1 año hacia atras
      // to: año actual.
      const data = {
        from: formatDateForFilter(moment().subtract(1, "year")),
        to: formatDateForFilter(moment()),
        companyRut: this.props.companyId,
        AuthorizedRut: this.props.userData.RUT,
        StatusId: this.props.selectedTipoSolicitud.value.value,
      };
      this.props.dispatch(loadDataGrid(data));
      this.setState({ filtersLoaded: true });
    }
  }

  componentDidUpdate = (prev) => {
    if (this.props.dataSelectedShow && prev.dataSelectedShow !== this.props.dataSelectedShow) {
      this.handleModalVer()
    }
  }

  componentWillUnmount = () => {
    this.props.dispatch(setCleanSolicitudConfirmar())
  }

  getButton = (row) => {
    if (row.data.EstadoSolicitud === "PENDIENTE") {
      if (row.data.TieneBorrador) {
        return <Button style={{ color: "white", backgroundColor: "#C5BE52" }} text="Borrador" type="normal" className="slimButton" onClick={() => this.getDraftComplain(row)} />;
      }
      return <Button text="Enviar" type="default" className="slimButton" />;
    }
    return <Button text="Reenviar" type="default" className="slimButton" />;
  }

  getDraftComplain = (row) => {
    this.props.dispatch(doGetDraft(this.props.companyId, row.data.RutTrabajador));
  }

  handleNewSolicitud = () => {
    this.props.dispatch(setStep(1));
    this.props.dispatch(setShowHideForm(true));
  }

  doGetComplains = (data) => {
    this.props.dispatch(setSolicitudesEmpresaFiltrada([]));
    const filtros = {
      from: formatDateForFilter(moment().subtract(1, "year")),
      to: formatDateForFilter(moment()),
      companyRut: this.props.companyId,
      AuthorizedRut: this.props.userData.RUT,
      StatusId: this.props.selectedTipoSolicitud.value.value,
    };
    if (validaciones.emptyText(this.props.sucursalId)) {
      filtros.idSucursal = this.props.sucursalId;
    }
    this.props.dispatch(loadDataGrid(filtros));
  }

  handleFilterChange = (text, filters) => {
    let currentFilters = [...filters];
    const _estadoSolicitud = currentFilters.find((e) => e.column === "estadoSolicitud");
    if (_estadoSolicitud && this.props.selectedTipoSolicitud.value.value !== _estadoSolicitud.value.value) {
      this.props.dispatch(setTipoSolicitud(this.mainFilter(_estadoSolicitud)));
      this.doGetComplains();
    } else {
      currentFilters = currentFilters.map((e) => e.column !== "estadoSolicitud" ? e : null).filter((e) => e);
      if (text) {
        currentFilters.push({
          column: "Id", filterValue: null, value: { text, value: text }, type: filterType.search,
        });
      }
      const ProposalDate = currentFilters.length > 0 ? currentFilters.filter((f) => f.column === "ProposalDate") : [];
      if (ProposalDate.length > 0) {
        const pivotFecha = ProposalDate.find((i) => i.column === "ProposalDate");
        let FechaDesde = null;

        if (this.state.doFilterProposalDate === true) {
          FechaDesde = this.state.ProposalDate;
        } else {
          FechaDesde = formatDateForFilter(moment().subtract(1, "year"));
        }
        const dateIsBefore = moment(pivotFecha.value.value.from).isBefore(moment(FechaDesde));
        // llamado al api cuando las fechas son menores con respecto a las que mando por primera vez
        if (dateIsBefore === true) {
          const data = {
            from: formatDateForFilter(moment(pivotFecha.value.value.from)),
            to: formatDateForFilter(moment(pivotFecha.value.value.to)),
          };
          this.doGetComplains(data);
          this.setState({
            doFilterProposalDate: true,
            ProposalDate: pivotFecha.value.value.from,
          });
        }
      }
      if (this.state.doFilterProposalDate && ProposalDate.length === 0) {
        // vuelvo a la carga de datos inicial. al limpiar el rango de fecha que fue menor a la orginal
        const data = {
          from: formatDateForFilter(moment().subtract(1, "year")),
          to: formatDateForFilter(moment()),
        };
        this.doGetComplains(data);
        this.setState({
          doFilterProposalDate: false,
          ProposalDate: null,
        });
      }
      const newData = filterData(this.props.listaSolicitudes, currentFilters);
      if (currentFilters.length > 0) {
        this.props.dispatch(setSolicitudesEmpresaFiltrada(newData));
      } else {
        this.props.dispatch(setSolicitudesEmpresaFiltrada(this.props.listaSolicitudes));
      }
    }
  }

  handleDctos = (link) => {
    window.open(link, "_blank");
  }

  handleViewGestionar = (row) => {
    this.props.dispatch(openCloseModalGestionar(true));
    this.props.dispatch(loadDataSelected(row));
  }

  handleModalVer = () => {
    const {
      Pools,
      AdditionalExams,
      PsychologicalExams,
      Workers,
      CompanyName,
      CostCenter,
      PetitionerName,
      AuthorizedRut,
      ProposalDate,
      ProposalDateEnd,
      WorkersQuota,
      RequestTypeDescription,
      defaultCityDescription
    } = this.props.dataSelectedShow;
    let _data = {};
    const _firstBenefit = [...Pools, ...AdditionalExams, ...PsychologicalExams].find(e => e.AchsOfficeDescription);
    _data.defaultCityDescription = _firstBenefit && _firstBenefit.AchsOfficeDescription ? _firstBenefit.AchsOfficeDescription : "";
    const baterias = Pools ? [{ key: `Baterías (${Pools.length})`, items: Pools.map((e) => e.Description) }] : [];
    const examenes = AdditionalExams ? [{ key: `Prestaciones médicas (${AdditionalExams.length})`, items: AdditionalExams.map((e) => e.ExamDescription) }] : [];
    const psicologicos = PsychologicalExams ? [{ key: `Evaluaciones psicológicas (${PsychologicalExams.length})`, items: PsychologicalExams.map((e) => e.ExamDescription) }] : [];
    _data.benefits = [...baterias, ...examenes, ...psicologicos];

    _data.workers = Workers ? Workers : [];
    _data.info = {
      CompanyName: CompanyName ? CompanyName : "",
      CostCenter: CostCenter ? CostCenter : "",
      PetitionerName: PetitionerName ? PetitionerName : "",
      AuthorizedRut: AuthorizedRut ? AuthorizedRut : "",
      ProposalDate: ProposalDate ? ProposalDate : "",
      ProposalDateEnd: ProposalDateEnd ? ProposalDateEnd : "",
      WorkersQuota: WorkersQuota ? WorkersQuota : "",
      RequestTypeDescription: RequestTypeDescription ? RequestTypeDescription : "",
      defaultCityDescription: defaultCityDescription ? defaultCityDescription : ""
    }
    this.setState({ openModalVer: true, dataModalVer: _data })
  }

  openModalVer = (row) => {
    this.props.dispatch(loadDataSelected(row, true));
  }

  closeModalVer = () => {
    this.setState({ openModalVer: false, dataModalVer: null })
  }

  render() {
    const { selectedTipoSolicitud, listaSolicitudesFiltrada } = this.props;
    const textStatus = selectedTipoSolicitud.value && selectedTipoSolicitud.value.text ? selectedTipoSolicitud.value.text : null;
    const columns = () => {
      const _columns = [];
      _columns.push(
        {
          caption: "N° de Solicitud",
          allowSearch: true,
          alignment: "center",
        },
        {
          caption: "Solicitante",
          allowSearch: true,
          alignment: "left",
        }
      );
      _columns.push({
        caption: "Fecha de envío",
        allowSearch: true,
        alignment: "center",
        dataType: "date",
        format: "dd/MM/yyyy",
      });
      if (textStatus === "aprobado") {
        _columns.push({
          caption: "Fecha de aprobación",
          allowSearch: true,
          alignment: "center",
          dataType: "date",
          format: "dd/MM/yyyy",
        });
      }
      if (textStatus === "rechazado" || textStatus === "rechazadoCallCenter") {
        _columns.push({
          caption: "Fecha de rechazo",
          allowSearch: true,
          alignment: "center",
          dataType: "date",
          format: "dd/MM/yyyy",
        });
      }
      _columns.push(
        {
          caption: "Cantidad de trabajadores",
          allowSearch: true,
          alignment: "center",
        },
        {
          caption: "Tipo de evaluación",
          allowSearch: true,
          alignment: "center",
        },
        {
          caption: "Baterías/Prestaciones",
          allowSearch: true,
          alignment: "center",
        }
      );
      //if (textStatus === "ingresado") {
      _columns.push({
        caption: "",
        allowSearch: true,
        alignment: "center",
      });
      //}
      return _columns;
    };
    const DataRow = (rowInfo) => {
      const _data = rowInfo.data ? rowInfo.data : null;
      return (<tbody className="dx-row">
        <tr className="main-row">
          <td style={{ textAlign: "center" }}>
            {_data.Id ? _data.Id : ""}
          </td>
          <td>
            <UserInfoColumn
              nombre={_data.PetitionerName ? _data.PetitionerName : ""}
              rut={_data.AuthorizedRut ? _data.AuthorizedRut : ""}
            />
          </td>
          <td style={{ textAlign: "center" }}>
            {_data.CreationDate ? moment(_data.CreationDate).format("L") : ""}
          </td>
          {(textStatus === "aprobado") &&
            <td style={{ textAlign: "center" }}>{_data.ApprovalDate ? moment(_data.ApprovalDate).format("L") : ""}</td>
          }
          {(textStatus === "rechazado") &&
            <td style={{ textAlign: "center" }}>{_data.RejectDate ? moment(_data.RejectDate).format("L") : ""}</td>
          }
          {(textStatus === "rechazadoCallCenter") &&
            <td style={{ textAlign: "center" }}>{_data.RejectCallCenterDate ? moment(_data.RejectCallCenterDate).format("L") : ""}</td>
          }
          <td style={{ textAlign: "center" }}>{_data.WorkersQuota ? _data.WorkersQuota : "0"}</td>
          <td style={{ textAlign: "center" }}>{_data.RequestTypeDescription ? _data.RequestTypeDescription : ""}</td>
          <td style={{ textAlign: "center" }}>{_data.Content ? _data.Content : ""}</td>
          {this.props.selectedTipoSolicitud.value.text === "ingresado" ?
            <td style={{ textAlign: "right" }}><Button
              text="Gestionar"
              type="success"
              className="slimButton"
              onClick={() => this.handleViewGestionar(rowInfo)}
            />
            </td>
            :
            <td style={{ textAlign: "right" }}><Button
              text="Ver"
              type="success"
              className="slimButton"
              onClick={() => this.openModalVer(rowInfo)}
            />
            </td>
          }
        </tr>
        {(textStatus === "rechazado" || textStatus === "rechazadoCallCenter") &&
          <tr className="notes-row">
            <td colSpan="7">
              <div className="row">
                <div className="col-1" style={{ fontWeight: "bold" }}>Comentario:</div>
                <div className="col-11">{rowInfo.data.RejectComment}</div>
              </div>
            </td>
          </tr>
        }
      </tbody>);
    };
    return (
      <React.Fragment>
        <ModalGestionar />
        <ModalVer
          data={this.state.dataModalVer}
          isOpen={this.state.openModalVer}
          close={this.closeModalVer}
        />
        <div className="table-wrapper">
          <TableFilter
            placeholder="Buscar solicitud"
            onChange={this.handleFilterChange}
            filters={this.props.filtrosSolicitudes}
            show
            buttons={
              {
                filter: { buttonName: "iconFilter", visible: true, buttonAction: null },
                document: null,
                download: { buttonName: "iconDownload", visible: false, buttonAction: null },
                newItem: null,
              }
            }
            selectedMainFilter={selectedTipoSolicitud}
            mainFilter={this.mainFilter()}
          />
          <DataGrid
            dataSource={listaSolicitudesFiltrada}
            showBorders={false}
            showColumnLines={false}
            showRowLines={false}
            noDataText=""
            className="custom-table agendamiento"
            rowAlternationEnabled
            hoverStateEnabled={false}
            activeStateEnabled={false}
            focusStateEnabled={false}

            onContentReady={(e) => {
              if (e.component.totalCount() === 0) {
                const config = {};
                config.addClass = "table-margin";
                const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
                const element = validaciones.noDataDOMElement(config, "Sin solicitudes");
                noDataSpan.appendChild(element);
              }
            }}
            loadPanel={{
              enabled: true,
              showPane: true,
              showIndicator: true,
              indicatorSrc: LoadingGif,
              text: "Cargando...",
            }}
            rowComponent={DataRow}
            columns={columns()}
          >
            <Paging
              defaultPageSize={20}
            />
            <Pager
              showNavigationButtons
              showInfo
              infoText={(page, total) => `Página ${page} de ${total}`}
            />
          </DataGrid>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  listaSolicitudes: state.confirmacionSolicitudesAgendaSel.listaSolicitudes,
  listaSolicitudesFiltrada: state.confirmacionSolicitudesAgendaSel.listaSolicitudesFiltrada,
  filtrosSolicitudes: state.confirmacionSolicitudesAgendaSel.filtrosSolicitudes,
  shouldUpdateDataGrid: state.confirmacionSolicitudesAgendaSel.shouldUpdateDataGrid,
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
  userData: state.global.userData,
  isOpenModalGestionar: state.confirmacionSolicitudesAgendaSel.isOpenModalGestionar,
  selectedTipoSolicitud: state.confirmacionSolicitudesAgendaSel.selectedTipoSolicitud,
  dataSelectedShow: state.confirmacionSolicitudesAgendaSel.dataSelectedShow
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(TableSolicitudes);
